<div class="notification-tabs" role="tablist">
  <button
    type="button"
    role="tab"
    [class.active]="activeTab() === 'all'"
    [attr.aria-selected]="activeTab() === 'all'"
    (click)="setTab('all')"
  >
    All
  </button>
  <button
    type="button"
    role="tab"
    [class.active]="activeTab() === 'messages'"
    [attr.aria-selected]="activeTab() === 'messages'"
    (click)="setTab('messages')"
  >
    Messages
  </button>
  <button
    type="button"
    role="tab"
    [class.active]="activeTab() === 'alerts'"
    [attr.aria-selected]="activeTab() === 'alerts'"
    (click)="setTab('alerts')"
  >
    Alerts
  </button>
</div>

@if (loading()) {
  <p class="notification-status">Loading notifications...</p>
} @else if (error()) {
  <p class="notification-status notification-status--error">{{ error() }}</p>
} @else if (filteredNotifications().length === 0) {
  <p class="notification-status">No notifications.</p>
} @else {
  <ul class="notification-list">
    @for (item of filteredNotifications(); track item.notificationId) {
      <li class="notification-row" (click)="openDetail(item)">
        <span
          class="notification-dot"
          [class.notification-dot--message]="item.notificationType === NotificationTypes.message"
          [class.notification-dot--alert]="item.notificationType === NotificationTypes.alert"
        ></span>
        <div class="notification-row__content">
          <p class="notification-row__message">{{ item.message }}</p>
          <span class="notification-row__date">{{ item.createdDateTime | date: 'shortDate' }}</span>
        </div>
        <button
          type="button"
          class="notification-row__dismiss"
          aria-label="Dismiss notification"
          (click)="dismiss($event, item.notificationId)"
        >
          ×
        </button>
      </li>
    }
  </ul>

  <button type="button" class="dismiss-all-btn" (click)="dismissAll()">
    Dismiss All
  </button>
}
